<template>
  <div class="mobile-home">
    <!-- 轮播图 -->
    <div class="banner-section">
      <el-carousel :interval="4000" height="200px">
        <el-carousel-item v-for="(item, index) in banners" :key="index">
          <img :src="item.url" :alt="item.title" class="banner-img">
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 客户案例 -->
    <div class="section">
      <div class="section-title">客户案例</div>
      <div class="case-list">
        <div class="case-item" v-for="(item, index) in caseList" :key="index" @click="goToCase(item)">
          <img :src="item.image" :alt="item.title">
          <!-- <div class="case-info">
            <div class="title">{{ item.title }}</div>
            <div class="desc" v-html="item.content"></div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- 新闻资讯 -->
    <div class="section">
      <div class="section-title">新闻资讯</div>
      <div class="news-list">
        <div class="news-item" v-for="(item, index) in newsList" :key="index" @click="goToNews(item)">
          <div class="news-info">
            <div class="title">{{ item.title }}</div>
            <div class="desc" v-html="item.content"></div>
            <div class="time">{{ item.createTime }}</div>
          </div>
          <img :src="item.image" :alt="item.title" class="news-img">
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="contact-section">
      <div class="contact-title">联系我们</div>
      <div class="contact-item">
        <div class="desc" v-html="contact.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { articleList, articleInfo } from '@/api/index'

export default {
  name: 'MobileHome',
  data() {
    return {
      caseList: [],
      newsList: [],
      contact: {}
    }
  },
  computed: {
    banners() {
      return this.$store.state.getHomeData.sliderList || []
    },
    topNav() {
      const navList = this.$store.state.getHomeData.topNav
      const idMap = {
        '/': 0,
        '/product': 11,
        '/case': 2,
        '/industry': 3,
        '/new': 4,
        '/about': 6,
        '/contact': 7
      }
      return navList.map(item => ({
        ...item,
        id: idMap[item.url] || item.id || 0
      }))
    },
  },
  created() {
    // 确保导航数据加载
    if (!this.$store.state.getHomeData.topNav || !this.$store.state.getHomeData.topNav.length) {
      this.$store.dispatch('getHomeData')
    }
    // 如果 store 中没有数据，则重新获取
    if (!this.$store.state.getHomeData.sliderList.length) {
      this.$store.dispatch('getHomeData')
    }
    // 获取客户案例数据
    this.getCaseList()
    // 获取新闻资讯数据
    this.getNewsList()
    // 获取联系我们数据
    this.getContact()
  },
  methods: {
    getCaseList() {
      articleList({ classify_id: 7 }).then(res => {
        if (res.code === 200) {
          this.caseList = res.data.rows || []
        }
      })
    },
    getNewsList() {
      articleList({ classify_id: 25 }).then(res => {
        if (res.code === 200) {
          this.newsList = res.data.rows || []
        }
      })
    },
    getContact() {
      articleInfo({id: 7}).then(res => {
        this.contact = res.data
      })
    },
    goToCase(item) {
      this.$router.push(`/case?id=${item.id}`)
    },
    goToNews(item) {
      this.$router.push(`/newsDetail?id=${item.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-home {
  padding: 15px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.banner-section {
  margin: -15px -15px 15px -15px;
  background: #fff;
  padding: 15px 0;
  width: calc(100% + 30px);
  box-sizing: border-box;

  :deep(.el-carousel) {
    width: 100%;
  }

  :deep(.el-carousel__container) {
    width: 100%;
  }

  :deep(.el-carousel__item) {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
  }

  :deep(.el-carousel__indicators) {
    bottom: 0;
  }

  .banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.section {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  width: 100%;
  box-sizing: border-box;

  .section-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
    padding-left: 10px;
    border-left: 4px solid #2c9dcf;
  }
}

.case-list {
  width: 100%;
  box-sizing: border-box;

  .case-item {
    margin-bottom: 15px;
    background: #f8f8f8;
    border-radius: 6px;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;

    img {
      // width: 100%;
      height: 240px;
      object-fit: cover;
    }

    .case-info {
      padding: 12px;
      width: 100%;
      box-sizing: border-box;

      .title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 8px;
        word-break: break-all;
      }

      .desc {
        font-size: 14px;
        color: #666;
        line-height: 1.5;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        overflow: hidden;
      }
    }
  }
}

.news-list {
  width: 100%;
  box-sizing: border-box;

  .news-item {
    display: flex;
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
    width: 100%;
    box-sizing: border-box;

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }

    .news-info {
      flex: 1;
      margin-right: 10px;
      min-width: 0;

      .title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 8px;
        line-height: 1.4;
        word-break: break-all;
      }

      .desc {
        font-size: 14px;
        color: #666;
        margin-bottom: 8px;
        line-height: 1.5;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;

        :deep(p) {
          margin: 0;
        }

        :deep(img) {
          display: none;
        }
      }

      .time {
        font-size: 12px;
        color: #999;
      }
    }

    .news-img {
      width: 100px;
      height: 70px;
      object-fit: cover;
      border-radius: 4px;
      flex-shrink: 0;
    }
  }
}

.contact-section {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
  .contact-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
    padding-left: 10px;
    border-left: 4px solid #2c9dcf;
  }

  .contact-item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    width: 100%;
    box-sizing: border-box;

    &:last-child {
      margin-bottom: 0;
    }

    i {
      font-size: 20px;
      color: #2c9dcf;
      margin-right: 10px;
      flex-shrink: 0;
    }

    span {
      font-size: 14px;
      color: #666;
      word-break: break-all;
      line-height: 1.4;
    }
  }
}
</style>
